import { render, staticRenderFns } from "./CopyrightFooter.vue?vue&type=template&id=520b9617&scoped=true"
import script from "./CopyrightFooter.vue?vue&type=script&lang=js"
export * from "./CopyrightFooter.vue?vue&type=script&lang=js"
import style0 from "./CopyrightFooter.vue?vue&type=style&index=0&id=520b9617&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b9617",
  null
  
)

export default component.exports